

export const heading = [
    "Expense",
    "Employee",
    "Cost",
    "Reason",
    "Transaction date",
    "Receipt",
    ""
]

export const tableData = [
    {
        id: 0,
        expense: "Expense title1",
        employee: "Kevin So",
        cost: "20023",
        transaction_date: "07/08/2023",
        expensed_date: "05/12/2023",
        receipt: true,
    },
    {
        id: 1,
        expense: "Expense title2",
        employee: "Alen Bryan",
        cost: "15624",
        transaction_date: "24/05/2023",
        expensed_date: "31/08/2023",
        receipt: true,
    },
    {
        id: 2,
        expense: "Expense title3",
        employee: "Tom Kit",
        cost: "758",
        transaction_date: "17/04/2023",
        expensed_date: "16/01/2023",
        receipt: false,
    },    
]